"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdGrid_1 = require("views/stdGrid");
const menuButtons_1 = require("models/menuButtons");
const globals_1 = require("models/globals");
const boutons_1 = require("../outils/boutons");
//TODO : supprimer les appels de php inutiles
class Admin extends stdGrid_1.default {
    constructor(app, name) {
        super(app, name, {
            datatableName: "sortiesdatatable",
            columns: [
                { id: "drag", header: "...", template: "<div class='webix_drag_handle'></div>", width: 35 },
                { id: "unid", header: "N°", hidden: false, width: 60, css: { "text-align": "right" } },
                { id: "date", editor: "date", header: "Date",
                    sort: "raw", format: webix.i18n.dateFormatStr },
                // { map:"(date)#date#", editor:"date", header:"Date"},
                { id: "heure", editor: "text", header: "Heure", width: 70, format: "99:99" },
                { id: "lieu", editor: "text", header: "Lieu", width: 200 },
                { id: "animateur", editor: "text", header: "Animé par", width: 100 },
                { id: "vitesse", editor: "text", header: "Vitesse", width: 80 },
            ],
            title: ("Sorties CMC"),
            boutons: [menuButtons_1.ajouterButton, menuButtons_1.supprimerButton, boutons_1.enregistrerButton, boutons_1.envoyerButton, boutons_1.envoyerSMoins1Button],
            resizeColumn: true,
            searchFieldHint: ("Recherche désignation ..."),
            // urlData : phpPath + "sorties.json",
            // saveData : {
            // 	updateFromResponse : true,
            // 	"insert" : phpPath + "articles.php?option=insertEmpty",
            // 	"update" : phpPath + "articles.php?option=update",
            // 	"delete" : phpPath + "articles.php?option=delete",
            // },
            scheme: {
                $export: function (obj) {
                    return { value: obj.value, number: webix.i18n.numberFormat(obj.number) };
                }
            },
            // Les contrôles simples sont ici
            rules: {
                date: webix.rules.isNotEmpty,
                heure: webix.rules.isNotEmpty,
            }
        });
    }
    enregistrerLignes() {
        // vérification de la conformité des lignes
        if (!this.currentGrid.validate()) {
            webix.alert((0, globals_1._)("Vous avez des erreurs dans les lignes, veuillez corriger pour valider"));
            // return;
        }
        // compléter les informations de chaque ligne
        let gridId = this.currentGrid.getFirstId();
        let item = this.currentGrid.getItem(gridId);
        let numLigne = 0;
        let me = this;
        while (item) {
            numLigne++;
            item["numLigne"] = numLigne;
            gridId = this.currentGrid.getNextId(gridId, 1);
            item = this.currentGrid.getItem(gridId);
        }
        // Enregistrement global
        // Array des données de la table
        let payload = this.currentGrid.serialize();
        // de array vers JSON
        // suite au passage en V10 suppression de la ligne suivante
        // let vv = JSON.stringify({...payload})
        // Enregistrement
        // @ts-ignore
        let promise = webix.ajax().headers({ "Content-type": "application/json" })
            .post(globals_1.phpPath + "listeSorties.php?option=savejson&dd=" + this.dataDir, { payload });
        promise.then(function (result) {
            if (result.json().success == false) {
                let factureValideField = me.$$("factureValide");
                factureValideField.setValue(result.json().message);
                webix.alert(result.json().message);
                return;
            }
            webix.alert("Données enregistrées");
        });
        promise.catch(function () {
            webix.alert((0, globals_1._)("Erreur d'enregistrement des lignes de document"));
        });
        return;
        // fin enregistrement global
    }
    envoyerListe() {
        let promise = webix.ajax().get(globals_1.phpPath + "listeSorties.php?option=sendList&dd=" + this.dataDir);
        promise.then(function (result) {
            // webix.alert(result.responseText);
            if (result.json().success == false) {
                webix.alert(result.json().message);
                return;
            }
            else {
                webix.alert(result.json().message);
            }
        });
    }
    envoyerSMoins1Liste() {
        let promise = webix.ajax().get(globals_1.phpPath + "listeSorties.php?option=sendListS1&dd=" + this.dataDir);
        promise.then(function (result) {
            // webix.alert(result.text);
            if (result.json().success == false) {
                webix.alert(result.json().message);
                return;
            }
            else {
                webix.alert(result.json().message);
            }
        });
    }
    init(baseview) {
        super.init(baseview);
        let me = this;
        const vv = this.getUrlString();
        this.dataDir = vv.substring(vv.length - 16) + "/";
        // const listeSorties = $$("listeSorties") as webix.ui.datatable;
        // listeSorties.load("php/sorties.json");
        this.listeSorties = $$("sortiesdatatable");
        this.listeSorties.load(globals_1.phpPath + "listeSorties.php?option=toutesSorties&dd=" + this.dataDir);
        // autres fonctions
        let menu = this.$$("stdGridMenu");
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "button-add":
                    me.ajouter();
                    break;
                case "button-del":
                    me.supprimer();
                    break;
                // case "button-dup" :
                // 	me.dupliquer();
                // 	break;
                case "enregistrerButton":
                    me.enregistrerLignes();
                    break;
                case "envoyerButton":
                    me.envoyerListe();
                    break;
                case "envoyerSMoins1Button":
                    me.envoyerSMoins1Liste();
                    break;
            }
        });
        $$("articlesImprimerTableButton").show();
        $$("actualiserButton").hide();
    }
}
exports.default = Admin;
